// extracted by mini-css-extract-plugin
export default {"modal":"onboard_modal__FxBTt","button":"onboard_button__-Rbmm","error":"onboard_error__JJMVF","addBtn_stl":"onboard_addBtn_stl__RkPhu"};